import { HistoryHelper } from "../Everou/_helpers";
import { LocalStorageHelper } from "../Everou/_helpers";
import { CommonStore } from "../Everou/_reducers/common.reducer";
import { StoreManager } from "../Everou/StoreManager";
import { PMSModules } from "./PMSModules";
import { PMSActiveOrganizationStore } from "./_stores/PMSActiveOrganizationStore";

export const PMSStoreSubscriptions = {
    subscribe,
};

function subscribe() {
    StoreManager.subscribeFnToStore(persistPMSSelectedModuleToUrl);
    StoreManager.subscribeFnToStore(persistPMSDataToLocalStorage);
}

function persistPMSSelectedModuleToUrl(getState) {
    HistoryHelper.pushToUrl(
        PMSModules.getUrlForModule(
            CommonStore.selectors.getSelectedModuleId(getState())
        )
    );
}

// The chosen organization survives a reload: it drives the header branding and
// the scope of Customization/Integrations, so losing it on every refresh made
// the app silently fall back to "the first organization". The shape mirrors
// the state tree (PMSStore mounts this field under pms.activeOrganization) so
// PersistedStateLoader hydrates it as-is; `isRequesting` is left out because
// this field never requests anything.
//
// Subscribers run on every dispatched action and combineState reads, parses
// and rewrites the whole persisted blob, so writing unconditionally would pay
// that cost hundreds of times for a value that changes once in a session.
let lastPersistedOrganizationUid;

function persistPMSDataToLocalStorage(getState) {
    const organizationUid = PMSActiveOrganizationStore.selectorGet(getState());
    if (organizationUid === lastPersistedOrganizationUid) return;

    lastPersistedOrganizationUid = organizationUid;
    LocalStorageHelper.combineState({
        pms: {
            activeOrganization: {
                value: organizationUid,
            },
        },
    });
}
